<template>
  <div class="container bottom-fix-padding">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/baggage-calc')"></span>
    </div>
    <div class="title">邮寄地址信息</div>
    <div class="main">
      <div class="text-center"><img class="full-image" src="../../assets/img/baggage/banner.png"></div>
      
      <router-link to="/baggage-step2/from">
        <div class="in-address" >
          <div class="move-title">寄件地址 <span class="arrow-right pull-right"> <span class="icon-chevron-right"></span> </span></div>
          <div v-if="!order.data.out_street" class="address-empty">请填写澳洲寄件地址</div>
          <div v-else>
          <div class="address-detail">{{order.data.out_name}}, {{order.data.out_phone}}<br><span v-show="order.data.out_unit">{{order.data.out_unit}},</span> {{order.data.out_street}}<br>{{order.data.out_suburb}}, {{order.data.out_state}}, {{order.data.out_postcode}}</div>
          </div>
        </div>
      </router-link>

      <div class="hr"></div>

      <router-link to="/baggage-step2/to">
        <div class="in-address" >
          <div class="move-title">收件地址 <span class="arrow-right pull-right"> <span class="icon-chevron-right"></span> </span></div>
          <div v-if="!order.data.home_address[0].home_address" class="address-empty">请填写收件地址</div>
          <div v-else>
          <div class="address-detail">{{order.data.home_address[0].home_name}},{{order.data.home_address[0].home_phone}}<br> {{order.data.home_address[0].home_address}}</div>
          </div>
        </div>
      </router-link>

      <div class="hr"></div>

      <div v-for="(item, index) in order.data.home_address">
        <div v-if="index>0">
        <div @click="goto('/baggage-step2/to-more?wpKey='+index)">
          <div class="in-address" >
            <div class="move-title">收件地址 {{order.data.home_address.length>1 ? index+1 : ''}} <span class="arrow-right pull-right"> <span class="icon-chevron-right"></span> </span></div>
            <div class="address-detail">{{item.home_name}}, {{item.home_phone}}<br> {{item.home_address}}</div>
          </div>
        </div>
        <div class="hr"></div>
        </div>
      </div>

      <div class="more-detail">
        <span class="check-detail"></spab><span class="icon-plus" style="color:#fe9567"></span> <router-link to="/baggage-step2/to-more" class="waypoint">额外收件地址</router-link></span>
      </div>
    </div>


    <div class="btn-box-fix">
      <div class="btn-container">
        <div class="btn" @click="checkSubmit()" :class="{ active: allFilled()}" >下一步</div>
      </div>
    </div>
    <img :src="pixelURL('baggage','dizhi')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'step3',
  data () {
    return {
      'order':{}
    }
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "baggage"){
        this.order = localParsed;
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
  },
  methods: {
    allFilled(){
       if(this.order.data.out_name &&
          this.order.data.out_phone &&
          this.order.data.out_street &&
          this.order.data.out_suburb &&
          this.order.data.out_state &&
          this.order.data.out_postcode &&
          this.order.data.out_parking &&
          this.order.data.out_floor &&
          this.order.data.home_address[0].home_name &&
          this.order.data.home_address[0].home_address &&
          this.order.data.home_address[0].home_phone ){
            return true;
        }
    },
    checkSubmit(){
        if(this.allFilled()){
            this.orderUpdateAll('/baggage-step3');
        }
        else{
            alert('请填写完所有地址信息')
        }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.main{
  padding:20px 20pt 0 20pt;
}
.full-image{
  max-width:80%;
  margin-bottom:14px;
}
.hr{
  border-top:1px solid #eee;
  margin:16pt 0;
}
.address-empty{
  color:#ccc;
  font-size:1.2em;
}

.address-detail{
  color:#666;
  font-size:1.1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.address-parking{
  color:#aaa;
  font-size:1em;
}

.arrow-right{
  color:#ddd;
}
.move-title{
  font-weight:bold;
  font-size:1.2em;
  color:#555;
  margin-bottom:4pt;
}

.waypoint{
  font-weight:bold;
  font-size:1.2em;
  color:#777;
  margin-bottom:4pt;
}

select{
  -webkit-appearance: none;
  border: 0;
  outline: 0;
  background-color: transparent;
  width: 100%;
  font-size: inherit;
  height: 45px;
  line-height: 45px;
  position: relative;
  z-index: 1;
}

.fade-enter-active{
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.check-detail{
  border: 2px solid #e3e3e3;
  padding: 8px 18px 8px 14px;
  margin-top: 14px;
  display: inline-block;
  border-radius: 50px;
}

.more-detail{
  text-align:center;
  margin-bottom:20px;
}

</style>



// WEBPACK FOOTER //
// src/pages/baggage/step2.vue